module.exports = __webpack_public_path__ + "images/hikakaku-sad_f05d80d2e991cf1e776c29cf3680585b.png";